export const EXPORT_FIELDS_CONFIG_VERSION = 2;
export const INTERACTION_EXPORT_FIELDS = [
    {
        key: "InteractionStartDate",
        label: "Start Date",
        visible: true,
        order: 0,
        category: "core",
    },
    {
        key: "InteractionFinalAction",
        label: "Final Action",
        visible: true,
        order: 1,
        category: "core",
    },
    {
        key: "ToFilterObjectName",
        label: "Contacted Name",
        visible: true,
        order: 2,
        category: "metadata",
    },
    {
        key: "ToObjectName",
        label: "Recipient Name",
        visible: true,
        order: 3,
        category: "core",
    },
    {
        key: "CallDurationSeconds",
        label: "Incoming Call Duration",
        visible: true,
        order: 4,
        category: "timing",
    },
    {
        key: "ReadInSeconds",
        label: "Read Time",
        visible: true,
        order: 5,
        category: "timing",
    },
    {
        key: "CallbackInSeconds",
        label: "Time to Callback",
        visible: true,
        order: 6,
        category: "timing",
    },
    {
        key: "MessageBody",
        label: "Message Body",
        visible: true,
        order: 7,
        category: "core",
    },
    {
        key: "Id",
        label: "Interaction ID",
        visible: false,
        order: 8,
        category: "core",
    },
    {
        key: "InteractionPropertyId",
        label: "Interaction Property ID",
        visible: false,
        order: 9,
        category: "core",
    },
    {
        key: "InteractionStartDateUtc",
        label: "Start Date (UTC)",
        visible: false,
        order: 10,
        category: "core",
    },
    {
        key: "InteractionEndDateUtc",
        label: "End Date (UTC)",
        visible: false,
        order: 11,
        category: "core",
    },
    {
        key: "FromCallbackNumber",
        label: "Callback Number",
        visible: true,
        order: 12,
        category: "core",
    },
    {
        key: "ToFilterObjectAccountId",
        label: "Account ID",
        visible: false,
        order: 13,
        category: "metadata",
    },
    {
        key: "ToFilterObjectAccountName",
        label: "Account Name",
        visible: false,
        order: 14,
        category: "metadata",
    },
    {
        key: "ToFilterObjectId",
        label: "Filter Object ID",
        visible: false,
        order: 15,
        category: "metadata",
    },
    {
        key: "ToFilterRequestedObject",
        label: "Requested Object",
        visible: false,
        order: 16,
        category: "metadata",
    },
    {
        key: "ToFilterPriority",
        label: "Priority",
        visible: false,
        order: 17,
        category: "core",
    },
    {
        key: "ToFilterReason",
        label: "Reason",
        visible: false,
        order: 18,
        category: "core",
    },
    {
        key: "ToFilterOriginator",
        label: "Originator",
        visible: false,
        order: 19,
        category: "core",
    },
    {
        key: "ToObjectId",
        label: "Recipient ID",
        visible: false,
        order: 20,
        category: "metadata",
    },
    {
        key: "NotificationInSeconds",
        label: "Notification Time (seconds)",
        visible: false,
        order: 21,
        category: "timing",
    },
    {
        key: "InteractionTotalTime",
        label: "Total Interaction Time (seconds)",
        visible: false,
        order: 22,
        category: "timing",
    },
    {
        key: "PushNotificationSentUtc",
        label: "Push Notification Sent (UTC)",
        visible: false,
        order: 23,
        category: "notification",
    },
    {
        key: "PushNotificationReceivedUtc",
        label: "Push Notification Received (UTC)",
        visible: false,
        order: 24,
        category: "notification",
    },
    {
        key: "SecureMessageSentUtc",
        label: "Message Sent (UTC)",
        visible: false,
        order: 25,
        category: "notification",
    },
    {
        key: "SecureMessageReadUtc",
        label: "Message Read (UTC)",
        visible: false,
        order: 26,
        category: "notification",
    },
    {
        key: "SecureMessageDeliveredUtc",
        label: "Message Delivered (UTC)",
        visible: false,
        order: 27,
        category: "notification",
    },
    {
        key: "SecureMessageSent",
        label: "Message Sent (Local)",
        visible: false,
        order: 28,
        category: "notification",
    },
    {
        key: "SecureMessageRead",
        label: "Message Read (Local)",
        visible: false,
        order: 29,
        category: "notification",
    },
    {
        key: "CallbackFromMessageIdUtc",
        label: "Callback Date (UTC)",
        visible: false,
        order: 30,
        category: "callback",
    },
    {
        key: "CallbackFromMessageId",
        label: "Callback Date (Local)",
        visible: true,
        order: 31,
        category: "callback",
    },
    {
        key: "CallbackDurationSeconds",
        label: "Callback Duration (seconds)",
        visible: false,
        order: 32,
        category: "callback",
    },
    {
        key: "CallbackFromMessageIdCount",
        label: "Callback Count",
        visible: true,
        order: 33,
        category: "callback",
    },
    {
        key: "IsBackup",
        label: "Is Backup",
        visible: false,
        order: 34,
        category: "metadata",
    },
    {
        key: "IsForwarded",
        label: "Is Forwarded",
        visible: false,
        order: 35,
        category: "metadata",
    },
    {
        key: "Dnis",
        label: "DNIS",
        visible: false,
        order: 36,
        category: "metadata",
    },
    {
        key: "CallFlow",
        label: "Call Flow",
        visible: false,
        order: 37,
        category: "core",
    },
    {
        key: "FormattedStartDate",
        label: "Start Date (Formatted)",
        visible: false,
        order: 38,
        category: "formatted",
    },
    {
        key: "FormattedEndDate",
        label: "End Date (Formatted)",
        visible: false,
        order: 39,
        category: "formatted",
    },
    {
        key: "FormattedDuration",
        label: "Duration (Formatted)",
        visible: false,
        order: 40,
        category: "formatted",
    },
    {
        key: "FormattedReadTime",
        label: "Read Time (Formatted)",
        visible: false,
        order: 41,
        category: "formatted",
    },
    {
        key: "FormattedCallback",
        label: "Callback Time (Formatted)",
        visible: false,
        order: 42,
        category: "formatted",
    },
    {
        key: "FormattedNotified",
        label: "Notification Time (Formatted)",
        visible: false,
        order: 43,
        category: "formatted",
    },
    {
        key: "FormattedPhone",
        label: "Phone Number (Formatted)",
        visible: false,
        order: 44,
        category: "formatted",
    },
    {
        key: "Legacy_Interaction_ID",
        label: "Legacy Interaction ID",
        visible: false,
        order: 45,
        category: "formatted",
    },
    {
        key: "Legacy_Date",
        label: "Legacy Date",
        visible: false,
        order: 46,
        category: "formatted",
    },
    {
        key: "Legacy_Type",
        label: "Legacy Type",
        visible: false,
        order: 47,
        category: "formatted",
    },
    {
        key: "Legacy_Duration",
        label: "Legacy Duration",
        visible: false,
        order: 48,
        category: "formatted",
    },
    {
        key: "Legacy_Read_Time",
        label: "Legacy Read Time",
        visible: false,
        order: 49,
        category: "formatted",
    },
    {
        key: "Legacy_Callback_Duration",
        label: "Legacy Callback Duration",
        visible: false,
        order: 50,
        category: "formatted",
    },
    {
        key: "Legacy_Message_Body",
        label: "Legacy Message Body",
        visible: false,
        order: 51,
        category: "formatted",
    },
];
export const getFieldDefinition = (key) => {
    return INTERACTION_EXPORT_FIELDS.find((field) => field.key === key);
};
export const getDefaultVisibleFields = () => {
    return INTERACTION_EXPORT_FIELDS.filter((field) => field.visible);
};
export const getFieldsByCategory = (category) => {
    return INTERACTION_EXPORT_FIELDS.filter((field) => field.category === category);
};
//# sourceMappingURL=exportFieldsConfig.js.map